import React from 'react';
import {
  Button, Container, Typography, Stack, Card, CardMedia, Skeleton,
} from '@mui/material';
import { Link } from 'react-router-dom';
import useCloudinaryUrl from '../../hooks/use-trip-photo';

const ASPECT_RATIO = (474 / 662) * 100;

export const TripReviewImage = ({
  isLoading,
  photoId = undefined,
}: {
  isLoading: boolean;
  photoId?: string | undefined;
}) => {
  const [imageUrl, isLoadingImage, error] = isLoading ? ['', true, undefined] : useCloudinaryUrl(photoId ?? '', { width: 662, height: 474 });

  return (
    <Card sx={{ width: '100%' }}>
      {isLoading || isLoadingImage || error ? (
        <Skeleton
          variant="rectangular"
          sx={{
            width: '100%',
            paddingTop: `${ASPECT_RATIO}%`,
          }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            paddingTop: `${ASPECT_RATIO}%`,
            position: 'relative',
          }}
        >
          <CardMedia
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            image={imageUrl}
          />
        </div>
      )}
    </Card>
  );
};

const TripReviewSubmitView = ({
  photoId,
  tripRequestId,
  isLoading,
}: {
  photoId?: string | undefined;
  tripRequestId?: string | undefined;
  isLoading: boolean;
}) => (
  <Container maxWidth="md" sx={{ my: 8.25 }}>
    <Stack alignItems="center" spacing={3}>
      <TripReviewImage isLoading={isLoading} photoId={photoId} />
      <Typography variant="h2">Your review was submitted!</Typography>
      <Typography>
        We appreciate your feedback which helps us enhance our services and provide you and other future travelers the best experiences possible.
      </Typography>
      <Button
        disabled={!tripRequestId}
        component={Link}
        to={`/trip-requests/${tripRequestId}`}
        variant="contained"
        sx={{
          width: {
            desktop: 'fit-content',
          },
        }}
      >
        Return to Main Page
      </Button>
    </Stack>
  </Container>
);

TripReviewSubmitView.defaultProps = {
  photoId: undefined,
  tripRequestId: undefined,
};

export default TripReviewSubmitView;
